import { webappsApi } from '@/infrastructure/Configuration'

export default class DynamicLinkService {
  constructor(httpClient) {
    this.httpClient = httpClient
  }

  getDynamicLinkProperty(value, booking) {
    const segments = (window.location.pathname || '').split('/').filter(Boolean)
    const locale = segments[0] || ''

    switch (value) {
      case 'HOTEL_CODE':
        return booking.stay.hotelCode
      case 'USER_NAME':
        return booking.customer.firstName
      case 'USER_LAST_NAME':
        return booking.customer.lastName
      case 'USER_EMAIL':
        return booking.customer.email
      case 'BOOKING_ID':
        return booking.bookingId
      case 'BOOKING_CHECK_IN':
        return booking.stay.checkInDate
      case 'BOOKING_CHECK_OUT':
        return booking.stay.checkOutDate
      case 'LANGUAGE':
        return locale.split('-')[0] || ''
      default:
        return ''
    }
  }

  async getEncryptedDynamicLink(linkElement, booking) {
    const data = await this.postDynamicLinkInfo({
      code: linkElement.code,
      context: this.getFullDynamicLinkContext(booking)
    })

    return data.url
  }

  getNonEncryptedDynamicLink(linkElement) {
    const params = linkElement.parameters
      .filter(param => param.value !== undefined)
      .map(param => `${param.key}=${param.value}`)
      .join('&')

    return `${linkElement.domain}?${params}`
  }

  prepareDynamicLinkParams(linkElement, booking) {
    return linkElement.parameters.map(param => {
      if (param.value !== undefined && param.dynamic) {
        return { ...param, value: this.getDynamicLinkProperty(param.value, booking) }
      }

      if (param.values !== undefined) {
        return {
          ...param,
          values: param.values.map(multiValueEntry => {
            if (multiValueEntry.dynamic) {
              return {
                ...multiValueEntry,
                value: this.getDynamicLinkProperty(multiValueEntry.value, booking)
              }
            }

            return multiValueEntry
          })
        }
      }

      return param
    })
  }

  getFullDynamicLinkContext(booking) {
    const segments = (window.location.pathname || '').split('/').filter(Boolean)
    const locale = segments[0] || ''

    const fullContext = {
      hotelCode: booking.stay.hotelCode,
      userName: booking.customer.firstName,
      userLastName: booking.customer.lastName,
      userEmail: booking.customer.email,
      bookingId: booking.bookingId,
      bookingCheckIn: booking.stay.checkInDate,
      bookingCheckOut: booking.stay.checkOutDate,
      language: locale.split('-')[0] || ''
    }

    return fullContext
  }

  async getDynamicLinkInfo(hotelCode) {
    const url = `${webappsApi}/links/dynamic` + (hotelCode ? `?hotelCode=${hotelCode}` : '')

    const { data } = await this.httpClient.get(url)
    return data
  }

  async postDynamicLinkInfo(dynamicLinkPayload) {
    const url = `${webappsApi}/links/dynamic`
    const { data } = await this.httpClient.post(url, dynamicLinkPayload)
    return data
  }
}
